<div class="loading-overlay" *ngIf="loading">
  <div class="loader-container">
    <div class="loader-spinner"></div>
    <p class="loader-text">Chargement en cours...</p>
  </div>
</div>

<div class="users-page-container">
  <div class="users-content-wrapper">
      <div class="users-table-container">
        <div class="px-4 py-4 border-b border-gray-200 flex items-center gap-4 relative">
          <div *ngIf="totalCredits > 0" class="total-credits-badge">
            <span class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-bold bg-blue-50 text-blue-700 border border-blue-200 whitespace-nowrap">
              <span class="material-symbols-outlined text-sm mr-1">account_balance_wallet</span>
              <span>{{ formatNumber(totalCredits) }} crédits</span>
            </span>
          </div>
          
          <div class="search-container-fixed flex-1 flex items-center justify-center gap-3">
            <div class="relative w-full max-w-xs">
              <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 material-symbols-outlined text-sm pointer-events-none">search</span>
              <input
                type="text"
                class="search-input-users w-full pl-9 pr-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                [(ngModel)]="searchTerm"
                placeholder="Rechercher par identifiant ou type..."
              />
            </div>
            <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-700 whitespace-nowrap">
              {{ filtered.length }} utilisateur{{ filtered.length > 1 ? 's' : '' }}
            </span>
          </div>
          
          <button 
            class="add-user-button bg-white hover:bg-blue-50 text-blue-900 rounded-full px-3 py-2 flex items-center justify-center transition-all duration-200 shadow-sm hover:shadow-md font-medium text-sm overflow-hidden"
            (click)="openAddUserModal()"
            title="Ajouter un utilisateur">
            <span class="material-symbols-outlined text-lg transition-transform duration-200 flex-shrink-0">add</span>
            <span class="add-user-button-text text-sm font-medium whitespace-nowrap">Ajouter un utilisateur</span>
          </button>
        </div>

        <div class="overflow-x-auto">
          <table class="users-table">
            <thead class="users-table-header">
              <tr>
                <th class="text-center w-16 sm:w-20">Calcul</th>
                <th class="cursor-pointer hover:bg-gray-50 transition-colors min-w-[150px] text-center" (click)="toggleSort('identifiant')">
                  <div class="flex items-center justify-center gap-2">
                    <span>Identifiant</span>
                    <span class="sort-icon text-xs" [ngClass]="sortField === 'identifiant' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                      <span *ngIf="sortField !== 'identifiant'">↕</span>
                      <span *ngIf="sortField === 'identifiant' && sortDirection === 'asc'">↓</span>
                      <span *ngIf="sortField === 'identifiant' && sortDirection === 'desc'">↑</span>
                    </span>
                  </div>
                </th>
                <th class="cursor-pointer hover:bg-gray-50 transition-colors min-w-[100px] text-center" (click)="toggleSort('type')">
                  <div class="flex items-center justify-center gap-2">
                    <span>Type</span>
                    <span class="sort-icon text-xs" [ngClass]="sortField === 'type' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                      <span *ngIf="sortField !== 'type'">↕</span>
                      <span *ngIf="sortField === 'type' && sortDirection === 'asc'">↓</span>
                      <span *ngIf="sortField === 'type' && sortDirection === 'desc'">↑</span>
                    </span>
                  </div>
                </th>
                <th class="cursor-pointer hover:bg-gray-50 transition-colors min-w-[200px] text-center" (click)="toggleSort('credit')">
                  <div class="flex items-center justify-center gap-2">
                    <span>Crédit</span>
                    <span class="sort-icon text-xs" [ngClass]="sortField === 'credit' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                      <span *ngIf="sortField !== 'credit'">↕</span>
                      <span *ngIf="sortField === 'credit' && sortDirection === 'asc'">↓</span>
                      <span *ngIf="sortField === 'credit' && sortDirection === 'desc'">↑</span>
                    </span>
                  </div>
                </th>
                <th class="min-w-[120px] text-center">Stop activé</th>
                <th class="text-center min-w-[200px]">Actions</th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr *ngFor="let u of filtered" class="users-table-row">
                <td class="users-table-cell text-center">
                  <input
                    type="checkbox"
                    class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer"
                    (click)="updateCalculation(u._id)"
                    [checked]="u.calculation"
                  />
                </td>
                <td class="users-table-cell font-medium text-gray-800">
                  {{ u.identifiant }}
                </td>
                <td class="users-table-cell">
                  <span class="badge-type" [ngClass]="'badge-' + u.typeAccount">
                    {{ u.typeAccount === 'smpp' ? 'API' : u.typeAccount === 'client' ? 'Client' : u.typeAccount === 'admin' ? 'Admin' : u.typeAccount === 'sous_admin' ? 'Sous Admin' : u.typeAccount }}
                  </span>
                </td>
                <td class="users-table-cell">
                  <div class="flex items-center gap-3">
                    <div class="flex-1">
                      <div class="text-sm font-semibold text-gray-800">
                        {{ formatNumber(u.credit) }}
                      </div>
                    </div>
                    <div class="flex items-center gap-2" *ngIf="u.typeAccount !== 'admin' && u.typeAccount !== 'sous_admin'">
                      <input
                        type="number"
                        class="credit-input w-24 px-3 py-1.5 border border-gray-200 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm transition-all hover:border-gray-300 bg-white"
                        [(ngModel)]="u.nouveauCredit"
                        placeholder="0"
                        (focus)="onCreditInputFocus($event)"
                        (input)="onCreditInputChange($event, u)"
                        (keydown.enter)="updateCredit(u._id)"
                      />
                      <button
                        class="credit-add-btn flex items-center justify-center w-8 h-8 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white rounded-md transition-all duration-200 shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
                        (click)="updateCredit(u._id)"
                        [disabled]="!u.nouveauCredit || u.nouveauCredit === 0"
                        title="Ajouter le crédit">
                        <span class="material-symbols-outlined text-base">add</span>
                      </button>
                    </div>
                    <div class="text-xs text-gray-400 italic" *ngIf="u.typeAccount === 'admin' || u.typeAccount === 'sous_admin'">
                      Non modifiable
                    </div>
                  </div>
                </td>
                <td class="users-table-cell">
                  <select
                    class="w-full max-w-40 px-3 py-2 border border-gray-200 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm bg-white transition-all hover:border-gray-300 cursor-pointer"
                    [(ngModel)]="u.activatedStop"
                    (change)="updateActivatedStop(u._id)"
                  >
                    <option [value]="true">Activé</option>
                    <option [value]="false">Désactivé</option>
                  </select>
                </td>
                <td class="users-table-cell text-center">
                  <div class="actions-row-modern">
                    <button 
                      type="button" 
                      class="btn-action-modern btn-export-new" 
                      (click)="exporterNouveauxStops(u._id)"
                      [disabled]="u.typeAccount === 'admin' || u.typeAccount === 'sous_admin'"
                      title="Exporter les nouveaux stops">
                      <span class="material-symbols-outlined">download</span>
                    </button>
                    <button 
                      type="button" 
                      class="btn-action-modern btn-export-all" 
                      (click)="exporterTousStops(u._id)"
                      [disabled]="u.typeAccount === 'admin' || u.typeAccount === 'sous_admin'"
                      title="Exporter tous les stops">
                      <span class="material-symbols-outlined">folder</span>
                    </button>
                    <button 
                      type="button" 
                      class="btn-action-modern btn-export-reponses" 
                      (click)="exporterReponses(u._id)"
                      [disabled]="u.typeAccount === 'admin' || u.typeAccount === 'sous_admin'"
                      title="Exporter les réponses">
                      <span class="material-symbols-outlined">comment</span>
                    </button>
                    <button 
                      type="button" 
                      class="btn-action-modern btn-delete" 
                      (click)="openDeleteModal(u)"
                      [disabled]="u.deletable === false"
                      [title]="u.deletable === false ? 'Ce compte ne peut pas être supprimé' : 'Supprimer l\'utilisateur'">
                      <span class="material-symbols-outlined">delete</span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
</div>

<div class="users-modal-overlay" *ngIf="showAddUserModal">
  <div class="users-modal-content" #addUserModalContent>
    <div class="users-modal-header">
      <div class="flex items-center gap-3 flex-1">
        <div class="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
          <span class="material-symbols-outlined text-white text-lg">person_add</span>
        </div>
        <h2 class="text-lg font-semibold text-gray-900">Ajouter un utilisateur</h2>
        <div *ngIf="user.typeAccount === 'smpp'" class="non-deletable-toggle ml-6">
          <input 
            class="sr-only" 
            type="checkbox" 
            id="nonDeletableHeader" 
            [(ngModel)]="user.nonDeletable" 
            name="nonDeletableHeader">
          <label class="non-deletable-toggle-label" for="nonDeletableHeader">
            <span class="material-symbols-outlined non-deletable-icon" *ngIf="!user.nonDeletable">lock_open</span>
            <span class="material-symbols-outlined non-deletable-icon" *ngIf="user.nonDeletable">lock</span>
            <span class="non-deletable-toggle-text">
              <span *ngIf="!user.nonDeletable">Supprimable</span>
              <span *ngIf="user.nonDeletable">Non supprimable</span>
            </span>
          </label>
        </div>
      </div>
      <button 
        class="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 active:bg-gray-200 transition-all duration-200 text-gray-400 hover:text-gray-600"
        (click)="closeAddUserModal()" 
        type="button"
        [disabled]="isAdding">
        <span class="material-symbols-outlined text-lg">close</span>
      </button>
    </div>
    
    <div class="users-modal-body">
      <form (ngSubmit)="addUser(); $event.preventDefault()" id="addUserForm">
        <div class="mb-6">
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div class="flex flex-col gap-1.5">
              <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                Identifiant
                <span class="text-red-500">*</span>
              </label>
              <input 
                type="text" 
                class="users-form-input" 
                [(ngModel)]="user.identifiant" 
                name="identifiant" 
                placeholder="Identifiant" 
                required 
                tabindex="1"
                autofocus />
            </div>
            
            <div class="flex flex-col gap-1.5">
              <div class="flex items-center justify-between">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                  Mot de passe
                  <span class="text-red-500">*</span>
                </label>
                <button 
                  type="button"
                  class="w-7 h-7 flex items-center justify-center rounded hover:bg-gray-100 transition-colors text-gray-500 hover:text-gray-700"
                  (click)="toggleModalPasswordVisibility()"
                  tabindex="-1"
                  [attr.aria-label]="showModalPassword ? 'Cacher le mot de passe' : 'Afficher le mot de passe'">
                  <span class="material-symbols-outlined text-base">
                    {{ showModalPassword ? 'visibility_off' : 'visibility' }}
                  </span>
                </button>
              </div>
              <input 
                [type]="showModalPassword ? 'text' : 'password'" 
                class="users-form-input" 
                [(ngModel)]="user.password" 
                name="password" 
                placeholder="••••••••" 
                required 
                tabindex="2" />
            </div>
            
            <div class="flex flex-col gap-1.5">
              <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                Type de compte
                <span class="text-red-500">*</span>
              </label>
              <select 
                class="users-form-select" 
                [(ngModel)]="user.typeAccount" 
                name="typeAccount" 
                required
                tabindex="3">
                <option [value]="" disabled selected>Choisir un type</option>
                <option value="client">Client</option>
                <option value="smpp">API</option>
                <option value="admin">Admin</option>
                <option value="sous_admin">Sous Admin</option>
              </select>
            </div>
          </div>
        </div>
        
        <div class="border-t border-gray-200 pt-4">
          <div class="space-y-3">
            <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
              <div class="flex items-start gap-3 flex-wrap">
                <div class="flex items-start gap-2.5 flex-1 min-w-[200px]">
                  <input 
                    class="mt-0.5 w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer" 
                    type="checkbox" 
                    id="addCredit" 
                    [(ngModel)]="user.addCredit" 
                    (ngModelChange)="onAddCreditToggle($event)"
                    name="addCredit">
                  <label class="flex flex-col cursor-pointer flex-1" for="addCredit">
                    <span class="text-sm font-medium text-gray-900">Ajouter du crédit initial</span>
                    <span class="text-xs text-gray-500 mt-0.5">Définir un montant de crédit au moment de la création</span>
                  </label>
                </div>
                
                <div *ngIf="user.addCredit" class="flex-1 min-w-[160px]">
                  <label class="block text-xs font-medium text-gray-600 mb-1.5">
                    Montant
                  </label>
                  <input 
                    type="text" 
                    class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm transition-all" 
                    [(ngModel)]="user.initialCredit" 
                    name="initialCredit" 
                    placeholder="0" 
                    inputmode="decimal"
                    #initialCreditInput
                    (focus)="onModalCreditFocus($event)"
                    (input)="onModalCreditInput($event)" />
                </div>
              </div>
            </div>
            
            <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
              <div class="flex items-start gap-2.5">
                <input 
                  class="mt-0.5 w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer" 
                  type="checkbox" 
                  id="activateStop" 
                  [(ngModel)]="user.activateStop" 
                  name="activateStop">
                <label class="flex flex-col cursor-pointer flex-1" for="activateStop">
                  <span class="text-sm font-medium text-gray-900">Activer le stop automatiquement</span>
                  <span class="text-xs text-gray-500 mt-0.5">Le système de stop sera activé dès la création</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    
    <div class="users-modal-footer">
      <button 
        type="button" 
        class="users-btn-secondary" 
        (click)="closeAddUserModal()"
        [disabled]="isAdding">
        <span class="material-symbols-outlined text-base">close</span>
        <span>Annuler</span>
      </button>
      <button 
        type="submit" 
        class="users-btn-primary" 
        form="addUserForm"
        [disabled]="isAdding">
        <span *ngIf="!isAdding" class="flex items-center gap-2">
          <span class="material-symbols-outlined text-base">add</span>
          <span>Créer</span>
        </span>
        <span *ngIf="isAdding" class="flex items-center gap-2">
          <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          <span>Création...</span>
        </span>
      </button>
    </div>
  </div>
</div>

<app-confirmation-modal
  [isVisible]="showDeleteModal"
  [config]="modalConfig"
  (confirm)="onModalConfirm()"
  (cancel)="onModalClose()"
  (close)="onModalClose()">
</app-confirmation-modal>
